import Vue from 'vue'
import Vuex from 'vuex'
import config from "@/settings/config.js"
import _axios from '@/services/axios'


Vue.use(Vuex)

const state = {
  AirTimeValues:{}
}

const mutations = {
  getAirTimeProducts(state,product)
  {
    state.AirTimeValues=product;
  }
}

const actions = {
  async getAirTimeProducts(state) {
    try {
      return await _axios.get(config.airtimeProduct).then(response=>
      {
        state.commit("getAirTimeProducts",response.data);
        return "complete";
      })
    } catch (error) {
      console.error(error)
    }
  }
}
const getters = {
  AirTimeValues:state=>state.AirTimeValues,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
